import React from 'react';
export default function useDocumentDirection(direction) {
    React.useEffect(() => {
        if (typeof document === 'undefined') {
            return;
        }
        const nodes = [
            document.documentElement,
            document.body,
            document.getElementById('app'),
            document.getElementById('modal-portal'),
            document.getElementById('popover-portal'),
        ].filter(Boolean);
        nodes.forEach(node => {
            node.dir = direction;
            node.dataset.layoutDirection = direction;
        });
    }, [direction]);
}
